import checkboxComponent from "@/components/child/form/checkbox.vue";
import comboComponent from "@/components/child/form/combo.vue";
import { Component, Prop } from "@/decorators";
import EnsaiosModel from "@/models/ensaiosModel";
import EnsaioService from "@/services/ensaioService";
import farmacopeiaService from "@/services/farmacopeiaService";

import EditComponentBase from "../editComponentBase";

@Component({
    components: {
        checkboxComponent,
        comboComponent,
    },
})
export default class EnsaioEditComponent extends EditComponentBase<EnsaiosModel> {
    farmacopeiaOptions: Array<Object> = [];

    @Prop({ type: Boolean, default: false }) CalledByShortCut: boolean;

    private async beforeMount() {
        await this.setProps(new EnsaioService(), "ensaios", new EnsaiosModel(), this.CalledByShortCut);

        this.farmacopeiaOptions = await farmacopeiaService.comboCached(this.usuarioLogado.franquiaId);
    }
}
